import { Outlet, useLocation, useSearchParams } from 'react-router-dom'
import { FormBlock } from '../../../../common/FormGenerator'
import { FormProvider, useForm } from 'react-hook-form'
import { getFormConfig } from '../../../../components/GrowthTools/GrowthToolsFiltration/settingsConfig'
import { GrowthToolsFiltration } from '../../../../components/GrowthTools/GrowthToolsFiltration'
import { PageLayout } from '../../../../components/PageLayout'
import { GrowthToolsTabs } from '../../../../components/GrowthTools/GrowthToolsTabs'
import { useEffect, useLayoutEffect, useMemo } from 'react'

const normalizeStringValue = (value: string | null): string => value?.trim() ?? ''

export const GrowthToolsLayout = () => {
  useLayoutEffect(() => {
    document.title = 'Инструменты роста'
  }, [])

  const { search } = useLocation()
  const [, setSearchParams] = useSearchParams()
  const defaultValues = useMemo(() => {
    const searchParams = new URLSearchParams(search)
    return {
      search: normalizeStringValue(searchParams.get('query')),
      source_type: normalizeStringValue(searchParams.get('source_type')) || 'all',
      content_type: normalizeStringValue(searchParams.get('content_type')) || 'all',
    }
  }, [search])

  const methods = useForm({ mode: 'all', defaultValues })
  const watchedSearch = methods.watch('search')
  const watchedSourceType = methods.watch('source_type')
  const watchedContentType = methods.watch('content_type')

  useEffect(() => {
    methods.reset(defaultValues)
  }, [defaultValues, methods])

  useEffect(() => {
    const timer = window.setTimeout(() => {
      const current = new URLSearchParams(search)
      const next = new URLSearchParams(search)
      const setOrDelete = (key: string, value: unknown, defaultValue = '') => {
        const v = String(value ?? '').trim()
        if (!v || v === defaultValue) next.delete(key)
        else next.set(key, v)
      }
      setOrDelete('query', watchedSearch)
      setOrDelete('source_type', watchedSourceType, 'all')
      setOrDelete('content_type', watchedContentType, 'all')
      if (next.toString() !== current.toString()) {
        setSearchParams(next, { replace: true })
      }
    }, 300)
    return () => window.clearTimeout(timer)
  }, [search, setSearchParams, watchedSearch, watchedSourceType, watchedContentType])

  return (
    <FormProvider {...methods}>
      <PageLayout
        title="Инструменты личностного роста"
        mainComponent={<Outlet />}
        sideComponent={<GrowthToolsFiltration />}
        searchComponent={<FormBlock formFieldConfig={getFormConfig('search')} />}
        topComponent={<GrowthToolsTabs />}
      />
    </FormProvider>
  )
}
